module.exports = __webpack_public_path__ + "media/newstyle/images/cover-revision-c141b75d52e4b9a10b497a6c07f3d2f9.png";